import { type Nil, isStringLiteralOfType, isString } from "@mcwd/typescript-type-guards";
import type { LocaleUrlPrefix } from "../../../../types-and-definitions/locale-defs/Locales.js";
import type { AnyFormFinalSetupObject } from "../../../../widgetDataTs.js";
import { getSelectedVideo, getSelectedDocuments } from "./getSelectedResources.js";
import { VideoGatedFormSettingsKey, type AnyFormSettingsKey } from "../../../form-settings/form-experience/form-settings-keys.js";

function getVideoUrlForEmail ({
  formSettingsKey, widgetSetup, localeUrlPrefix
}: {
  formSettingsKey: AnyFormSettingsKey | Nil;
  widgetSetup: AnyFormFinalSetupObject;
  customDocumentDownloadURL: string | Nil;
  localeUrlPrefix: LocaleUrlPrefix;
})
{
  if (isStringLiteralOfType(formSettingsKey, VideoGatedFormSettingsKey)) {
    const selectedVideo = getSelectedVideo(widgetSetup);
    if (selectedVideo != null) {
      const GatedVideoLegacyId = selectedVideo.legacyId;
      return `https://www.mastercontrol.com${ localeUrlPrefix }/resources/download/?vl=${ GatedVideoLegacyId }`;
    }
  }
  return null;
}

function getDocumentUrlForEmail ({
  widgetSetup, localeUrlPrefix
}: {
  widgetSetup: AnyFormFinalSetupObject;
  localeUrlPrefix: LocaleUrlPrefix;
}): string | null
{
  const selectedDocs = getSelectedDocuments(widgetSetup) ?? [];
  if (selectedDocs.length === 0) {
    return null;
  }
  const documentIds = selectedDocs.map((item) => item.legacyId).join(",");
  return `https://www.mastercontrol.com${ localeUrlPrefix }/resources/download/?dl=${ documentIds }`;
}

export function getResourceUrlForEmail (opts: {
  formSettingsKey: AnyFormSettingsKey | Nil;
  widgetSetup: AnyFormFinalSetupObject;
  customDocumentDownloadURL: string | Nil;
  localeUrlPrefix: LocaleUrlPrefix;
}): string | null
{
  const videoUrl = getVideoUrlForEmail(opts);
  if (videoUrl != null)
  {
    return videoUrl;
  }
  if (isString(opts.customDocumentDownloadURL))
  {
    return opts.customDocumentDownloadURL;
  }
  const docUrl = getDocumentUrlForEmail(opts);
  return docUrl;
}